export type BannerPage =
  | "login"
  | "lobby"
  | "calculator"
  | "newbie"
  | "red_packet"
  | "gems"
  | "weekly_pass"
  | "graduate_week"
  | "weekend_boost";

export interface BannerConfig {
  banner_title: string;
  banner_subtitle: string;
  banner_body: string;
  banner_image_url: string;
  banner_cta_text: string;
  banner_cta_link: string;
  banner_enabled: boolean;
  banner_sort_order: number;
  banner_page: BannerPage;
}

export const bannerConfigs: Record<BannerPage, BannerConfig> = {
  login: {
    banner_title: "龍來喬\n入盟有路線，越玩越到位",
    banner_subtitle: "首存 100%・二存 80%・三存 50%",
    banner_body: "紅包、寶石、週任務、會員身份一路解鎖。\n進來有人帶，留下才有局。\n加入龍來喬，朋友一起來，越喬越旺。",
    banner_image_url: "",
    banner_cta_text: "",
    banner_cta_link: "",
    banner_enabled: true,
    banner_sort_order: 1,
    banner_page: "login"
  },
  lobby: {
    banner_title: "龍來喬福利大廳",
    banner_subtitle: "新人入盟一路解鎖，畢業後持續升級",
    banner_body: "首存、二存、三存一路開啟。\n紅包、寶石、週任務、會員身份都在這裡。",
    banner_image_url: "",
    banner_cta_text: "查看我的下一步",
    banner_cta_link: "#next-step",
    banner_enabled: true,
    banner_sort_order: 1,
    banner_page: "lobby"
  },
  calculator: placeholderBanner("calculator", "新人禮試算器"),
  newbie: placeholderBanner("newbie", "新人七關"),
  red_packet: placeholderBanner("red_packet", "紅包池"),
  gems: placeholderBanner("gems", "寶石兌換"),
  weekly_pass: placeholderBanner("weekly_pass", "週通行證"),
  graduate_week: placeholderBanner("graduate_week", "畢業首週"),
  weekend_boost: placeholderBanner("weekend_boost", "週末耀旺")
};

function placeholderBanner(banner_page: BannerPage, title: string): BannerConfig {
  return {
    banner_title: title,
    banner_subtitle: "Banner 圖片與 CTA 預留",
    banner_body: "正式版可由後台設定圖片、手機版 Banner、排序、啟用狀態與 CTA。",
    banner_image_url: "",
    banner_cta_text: "",
    banner_cta_link: "",
    banner_enabled: false,
    banner_sort_order: 99,
    banner_page
  };
}
